import { Route, Routes } from "react-router-dom";
import Container from "../components/layout/Container";
import Rating from "../components/Shared/Rating/Rating";
import ActiveListing from "../components/UserListing/ActiveListing/ActiveListing";
import ReviewsGiven from "../components/UserListing/ReviewsGiven/ReviewsGiven";
import ReviewsReceieved from "../components/UserListing/ReviewsReceieved/ReviewsReceieved";
import SoldItems from "../components/UserListing/SoldItems/SoldItems";
import { products } from "../data/products";

const UserListing = () => {
  return (
    <Container>
      <div className="mt-10 flex flex-col gap-4">
        <Rating />
        <Routes>
          <Route
            path="sold"
            element={<SoldItems products={products} title="Sold Items" />}
          />
          <Route
            path="reviews-given"
            element={<ReviewsGiven products={products} title="Reviews Given" />}
          />
          <Route
            path="reviews-receieved"
            element={
              <ReviewsReceieved products={products} title="Reviews Receieved" />
            }
          />
          <Route
            path="/*"
            element={
              <ActiveListing products={products} title="Active Listing Ads" />
            }
          />
        </Routes>
      </div>
    </Container>
  );
};

export default UserListing;
